__webpack_require__.p = "https://alpha.bi-central.accounting.amazon.dev/";